






import { Component, Vue } from "vue-property-decorator";
import websocket from "@/../api/websocket";
import router from "@/router";

@Component
export default class NoMenu extends Vue {
  connect() {
    websocket.connect(
      () => router.push({ name: "main" }),
      () => router.push({ name: "error", params: { type: "connection" } })
    );
  }
}
